import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { coreTechNodes } from '@/mocks/jiuchou-business';

export default function CoreTech() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="核心技术"
            title="五项核心技术，构成一个乡村数字经济操作系统"
            subtitle="华辉数智负责 TOMA 掌中智能体开发，并承担车载卡激活系统、数字货架、数据看板等核心技术交付。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {coreTechNodes.map((node) => (
              <div
                key={node.no}
                className="group relative p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 rounded-lg bg-primary-500 flex items-center justify-center">
                    <span className="text-background-50 font-heading font-bold">{node.no}</span>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </div>
                <div className="mt-4 text-lg font-heading font-bold text-foreground-950">
                  {node.title}
                </div>
                <div className="mt-1 text-xs text-accent-600 font-medium">{node.subtitle}</div>
                <div className="mt-3 text-sm text-foreground-500 leading-relaxed">{node.desc}</div>
              </div>
            ))}

            {/* 第六张卡片：一句话概念 */}
            <div className="p-6 rounded-lg bg-foreground-950 border border-foreground-800 flex flex-col justify-center">
              <div className="text-2xl font-heading font-bold text-background-50 leading-snug">
                一笔交易，
                <br />
                一条数据链
              </div>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                从交易记录到数据看板、智能合约与多方协同，让每一次消费都沉淀为可运营的数字资产。
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-8 text-center text-xs text-foreground-500 leading-relaxed max-w-3xl mx-auto">
            注：数字人民币相关内容仅指数字人民币消费应用场景及相关技术服务，不代表华辉数智从事数字人民币发行或金融机构业务。
          </p>
        </Reveal>
      </div>
    </section>
  );
}